import { getSdk } from "./sdkService";
import { config } from "../config/config";
import { getLogger } from "../utils/logger";
import * as Sentry from "@sentry/browser";

let geoTimeout;

/**
 * Validates country code received in geolocation data object against valid countries.
 * @param {String} countryCode - ISO Country code received in geolocation.
 */
function checkValidCountries(countryCode) {
  const validCountries = config.get().allowedCountries;
  return validCountries.filter(countryObject => countryObject.code === countryCode).length > 0;
}

/**
 * Resolves one promise with true value after N time
 */
function geolocationTimeout() {
  return new Promise(resolve => {
    geoTimeout = setTimeout(() => resolve(true), config.get().geoblockingTimeout);
  });
}

export async function getGeolocation() {
  const sdk = await getSdk();
  return sdk.authenticationManager.getGeolocation();
}

/**
 * Gets current user geolocation data and checks if it is among the countries allowed to use the app.
 * @return {boolean} true if the country where the app being run is allowed by the service, false in other case.
 * If the network call to get the app's location fails or if the response of SPX takes longer than N secs,
 * this function will also return true in order to not block the users.
 */
export async function validateGeolocation() {
  try {
    const accessToApp = geolocationTimeout();
    const geolocation = await getGeolocation();
    return Promise.race([accessToApp, geolocation]).then(data => {
      if (!data.country) {
        return data;
      }
      clearTimeout(geoTimeout);
      getLogger().log(data, "Geolocation");
      return checkValidCountries(data.country);
    });
  } catch (error) {
    Sentry.captureException(error);
    return true;
  }
}
